import { z } from "zod";

export const TimeSeriesPointSchema = z.object({
  bucket: z.string(),
  value: z.number(),
});
export type TimeSeriesPoint = z.infer<typeof TimeSeriesPointSchema>;

export const MetaSchema = z
  .object({
    requestId: z.string().optional(),
    tookMs: z.number().optional(),
  })
  .passthrough();
export type Meta = z.infer<typeof MetaSchema>;

export const GranularitySchema = z.enum(["1m", "5m", "15m", "1h", "6h", "1d"]);
export type GranularityValue = z.infer<typeof GranularitySchema>;

export const MetricsEnvSchema = z.enum(["dev", "qa", "qa4", "stage", "prod"]);
export type MetricsEnvValue = z.infer<typeof MetricsEnvSchema>;

export const DefaultRangeSchema = z.object({
  from: z.string(),
  to: z.string(),
  granularity: z.string().optional(),
});
export type DefaultRange = z.infer<typeof DefaultRangeSchema>;
